import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Row, Col } from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'
import { FONTS } from '../../../constants'

class ResourceSummary extends React.Component {
  render() {
    const currentMonthSummary = get(this.props, 'currentMonthSummary')
    const headcountFullTime = get(currentMonthSummary, 'headcountFullTime', 0)
    const headcountSubcontract = get(currentMonthSummary, 'headcountSubcontract', 0)
    const chargeableFullTimePercent = get(currentMonthSummary, 'chargeableFullTimePercent', 0)
    const chargeableSubcontractPercent = get(currentMonthSummary, 'chargeableSubcontractPercent', 0)
    const onProjectFullTimePercent = get(currentMonthSummary, 'onProjectFullTimePercent', 0)
    const onProjectSubbcontractPercent = get(currentMonthSummary, 'onProjectSubbcontractPercent', 0)
    const dataHeadcount = {
      labels: ['Employee', 'Subcontrcator'],
      datasets: [{
        data: [headcountFullTime, headcountSubcontract],
        datalabels: { display: false },
        fillColor: "#79D1CF",
        strokeColor: "#79D1CF",
        backgroundColor: ['#5CB85C', '#7381DE'],
        hoverBackgroundColor: ['#5CB85C', '#7381DE'],
      }],
    }
    const dataChargeable = {
      labels: ['Employee', 'Subcontrcator'],
      datasets: [{
        data: [chargeableFullTimePercent, chargeableSubcontractPercent],
        datalabels: { display: false },
        fillColor: "#79D1CF",
        strokeColor: "#79D1CF",
        backgroundColor: ['#5CB85C', '#7381DE'],
        hoverBackgroundColor: ['#5CB85C', '#7381DE'],
      }],
    }
    const dataOnProject = {
      labels: ['Employee', 'Subcontrcator'],
      datasets: [{
        data: [onProjectFullTimePercent, onProjectSubbcontractPercent],
        datalabels: { display: false },
        fillColor: "#79D1CF",
        strokeColor: "#79D1CF",
        backgroundColor: ['#5CB85C', '#7381DE'],
        hoverBackgroundColor: ['#5CB85C', '#7381DE'],
      }],
    }
    const option = {
      cutoutPercentage: 70,
      legend: { display: false },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
      },
    }
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <Header>
          Resource Summary
        </Header>
        <ContainerChart>
          <ChartContainer>
            <LabelRow noGutters>
              <LabelChart>{ `Headcount Summary (${headcountFullTime + headcountSubcontract})` }</LabelChart>
            </LabelRow>
            <ChartRow noGutters>
              <ColInfo>
                <FirstCon>
                  <RowContent>
                    <TypeLabel>Employee</TypeLabel>
                  </RowContent>
                  <RowContent>
                    <NumLabel>{ headcountFullTime }</NumLabel>
                  </RowContent>
                </FirstCon>
                <SecondCon>
                  <RowContent>
                    <TypeLabel>Subcontrcator</TypeLabel>
                  </RowContent>
                  <RowContent>
                    <NumLabel> { headcountSubcontract }</NumLabel>
                  </RowContent>
                </SecondCon>
              </ColInfo>
              <ColChart>
                <Doughnut data={ dataHeadcount } options={ option } height={ 150 } />
              </ColChart>
            </ChartRow>
          </ChartContainer>
          <ChartContainer>
            <LabelRow noGutters>
              <LabelChart>{ 'Chargeable Summary (%)' }</LabelChart>
            </LabelRow>
            <ChartRow noGutters>
              <ColInfo>
                <FirstCon>
                  <RowContent>
                    <TypeLabel>Employee</TypeLabel>
                  </RowContent>
                  <RowContent>
                    <NumLabel>{ chargeableFullTimePercent } %</NumLabel>
                  </RowContent>
                </FirstCon>
                <SecondCon>
                  <RowContent>
                    <TypeLabel>Subcontrcator</TypeLabel>
                  </RowContent>
                  <RowContent>
                    <NumLabel> { chargeableSubcontractPercent } %</NumLabel>
                  </RowContent>
                </SecondCon>
              </ColInfo>
              <ColChart>
                <Doughnut data={ dataChargeable } options={ option } height={ 150 } />
              </ColChart>
            </ChartRow>
          </ChartContainer>
          <ChartContainer>
            <LabelRow noGutters>
              <LabelChart>{ 'On-Project Summary (%)' }</LabelChart>
            </LabelRow>
            <ChartRow noGutters>
              <ColInfo>
                <FirstCon>
                  <RowContent>
                    <TypeLabel>Employee</TypeLabel>
                  </RowContent>
                  <RowContent>
                    <NumLabel>{ onProjectFullTimePercent } %</NumLabel>
                  </RowContent>
                </FirstCon>
                <SecondCon>
                  <RowContent>
                    <TypeLabel>Subcontrcator</TypeLabel>
                  </RowContent>
                  <RowContent>
                    <NumLabel> { onProjectSubbcontractPercent } %</NumLabel>
                  </RowContent>
                </SecondCon>
              </ColInfo>
              <ColChart>
                <Doughnut data={ dataOnProject } options={ option } height={ 150 } />
              </ColChart>
            </ChartRow>
          </ChartContainer>
        </ContainerChart>
      </Wrapper>
    )
  }
}

export default ResourceSummary

const ContainerChart = styled.div`
  display: flex;
  justify-content: flex-end;
`
const Wrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
`
const Container = styled.div`
  padding-top: 1%;
  padding-left: 1%;
  padding-right: 1%;
  color: black;
`
const Header = styled.div`
  height: 50px;
  width: 100%;
  background: #404040;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  padding-left: 10px;
  align-items: center;
`
const ChartContainer = styled(Container)`
  width: 100%;
  height: 100% ;
  margin-bottom: 0px;
  margin-left: 0px;
  background:#FFFFFF;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
`
const LabelRow = styled(Row)`
  width: 100%;
  height: 20% ;
`
const ChartRow = styled(Row)`
  width: 100%;
  height: 80% ;
`
const LabelChart = styled.label`
  margin-left: 5%;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
`
const ColInfo = styled(Col)`
  width: 40%;
  height: 100% ;
`
const ColChart = styled(Col)`
  width: 60%;
  height: 100% ;
  padding-bottom: 5%;
`
const FirstCon = styled(Container)`
  height: 20%;
  margin-left:10%;
  margin-bottom:15%;
  padding-left:5%;
  border-left:8px solid #5CB85C;
`
const SecondCon = styled(Container)`
  height: 20%;
  margin-left:10%;
  margin-bottom:15%;
  padding-left:5%;
  border-left:8px solid #7381DE;
`
const TypeLabel = styled.label`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #7B7B7B  ;
  margin-bottom: 0%;
`
const NumLabel = styled.label`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-bottom: 0%;
`
const RowContent = styled(Row)`
  margin-left: 2%;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/components/resource-summary.js